import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { ROUTES } from './routes';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { ProtectedRoute, PublicOnly } from '../features/auth/ProtectedRoute';

// 페이지는 named export → default 래핑 후 lazy. 진입 시점에 청크 로드(초기 번들 축소).
const HomePage = lazy(() =>
  import('../features/home/HomePage').then((m) => ({ default: m.HomePage })),
);
const ProductsPage = lazy(() =>
  import('../features/products/ProductsPage').then((m) => ({ default: m.ProductsPage })),
);
const KeywordsPage = lazy(() =>
  import('../features/keywords/KeywordsPage').then((m) => ({ default: m.KeywordsPage })),
);
const StatsPage = lazy(() =>
  import('../features/stats/StatsPage').then((m) => ({ default: m.StatsPage })),
);
const CafesPage = lazy(() =>
  import('../features/cafes/CafesPage').then((m) => ({ default: m.CafesPage })),
);
const AccountsPage = lazy(() =>
  import('../features/accounts/AccountsPage').then((m) => ({ default: m.AccountsPage })),
);
const WorkersPage = lazy(() =>
  import('../features/workers/WorkersPage').then((m) => ({ default: m.WorkersPage })),
);
const NicknamesPage = lazy(() =>
  import('../features/nicknames/NicknamesPage').then((m) => ({ default: m.NicknamesPage })),
);
const UsersPage = lazy(() =>
  import('../features/users/UsersPage').then((m) => ({ default: m.UsersPage })),
);
const MePage = lazy(() => import('../features/profile/MePage').then((m) => ({ default: m.MePage })));
const SettingsPage = lazy(() =>
  import('../features/settings/SettingsPage').then((m) => ({ default: m.SettingsPage })),
);
const LoginPage = lazy(() =>
  import('../features/auth/LoginPage').then((m) => ({ default: m.LoginPage })),
);

const PAGES: Record<string, React.ComponentType> = {
  '/': HomePage,
  '/products': ProductsPage,
  '/keywords': KeywordsPage,
  '/stats': StatsPage,
  '/cafes': CafesPage,
  '/accounts': AccountsPage,
  '/workers': WorkersPage,
  '/nicknames': NicknamesPage,
  '/users': UsersPage,
  '/me': MePage,
  '/settings': SettingsPage,
};

function PageLoader() {
  return (
    <Center h="60vh">
      <Loader />
    </Center>
  );
}

export function AppRouter() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <Suspense fallback={<PageLoader />}>
              <LoginPage />
            </Suspense>
          </PublicOnly>
        }
      />
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          {ROUTES.map(({ to }) => {
            const Page = PAGES[to];
            const element = (
              <Suspense fallback={<PageLoader />}>
                <Page />
              </Suspense>
            );
            return to === '/' ? (
              <Route key={to} index element={element} />
            ) : (
              <Route key={to} path={to.slice(1)} element={element} />
            );
          })}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
